<app-spinner *ngIf="loading"></app-spinner>
<div *ngIf="!loading">
  <tyt-sub-nav [show]="show" [activeLiveStream]="activeLiveStream" [section]="mode"></tyt-sub-nav>
    <tyt-media-view
      [production]="production"
      [item]="currentItem"
      [mode]="mode"
      [user]="user"></tyt-media-view>

    <div class="sidebar">
      <ng-container *ngFor="let recentEpisode of recentEpisodes">
        <tyt-production-view *ngIf="recentEpisodes" class="mini" [production]="recentEpisode"
          [showImage]="mode !== 'podcasts'" [mode]="mode" limit="2">
        </tyt-production-view>
      </ng-container>
    </div>
</div>